class UserService {
    getUserId() {
        if(localStorage['user']){
            let user = JSON.parse(localStorage['user']);
            return user.userId;
        }
    }

    getUserName() {
        if(localStorage['user']){
            let user = JSON.parse(localStorage['user']);
            return user.userName;
        }
    }

    getEnquiryId() {
       // let enquiryId = localStorage.getItem('enquiryId');
        let user = JSON.parse(localStorage['user']);
        return user.enquiryId;
    }

    getBatchId() {
        // Get the first batch's batchId from the user's batches array
        let user = JSON.parse(localStorage['user'] || '{}');
        if (user.batches && user.batches.length > 0) {
            return user.batches[0].batchId;
        }
        return null;
    }

    getToken() {
        // let enquiryId = localStorage.getItem('enquiryId');
         let user = JSON.parse(localStorage['user'] || '{}');
         return user.token;
     }
}

export default new UserService();